import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeetingLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M163.2 133.07c-5.08 2.03-4.15 7.1 4.6 7.86 4.12.36 7.64 2.72 5.06 5.41-1.43 1.5-3.93 2.38-6.86 2.4l-8 .04 1.08 1.85 6.94-.04c11.23-.08 13.35-10.52 1.94-11.5-4.68-.4-8.37-2.58-4.07-4.3 5.23-2.1 9.25-1.13 31.12-1.36v-1.85c-21.94.22-26.18-.78-31.81 1.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint0_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.2 133.07c-5.08 2.03-4.15 7.1 4.6 7.86 4.12.36 7.64 2.72 5.06 5.41-1.43 1.5-3.93 2.38-6.86 2.4l-8 .04 1.08 1.85 6.94-.04c11.23-.08 13.35-10.52 1.94-11.5-4.68-.4-8.37-2.58-4.07-4.3 5.23-2.1 9.25-1.13 31.12-1.36v-1.85c-21.94.22-26.18-.78-31.81 1.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint1_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M149.3 81.67v-8.54a4.5 4.5 0 0 0-4.5-4.5H64.61"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint2_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M61.27 68.63h-2.5a4.5 4.5 0 0 0-4.5 4.5v60.7h95.02V88.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint3_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.78 73.36a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint4_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M159.1 155.87H44.47a1.75 1.75 0 0 1-1.74-1.6l-.01 5.84a2.1 2.1 0 0 0 2.1 2.1h113.9a2.1 2.1 0 0 0 2.1-2.1v-5.81a1.74 1.74 0 0 1-1.74 1.57"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint5_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m160.6 153.25-11.3-19.42H54.26l-11.3 19.42a1.75 1.75 0 0 0 1.5 2.62H159.1a1.74 1.74 0 0 0 1.51-2.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint6_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M151.46 141.95H52.2l3.7-6.58h91.84z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint7_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m119.9 149.5-.87-3.08a3.1 3.1 0 0 0-2.95-2.22h-28.6a3.1 3.1 0 0 0-2.95 2.22l-.88 3.08a2.62 2.62 0 0 0 2.52 3.34h31.22a2.63 2.63 0 0 0 2.52-3.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint8_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M119.9 149.5h-18.12v3.34h15.61a2.62 2.62 0 0 0 2.52-3.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint9_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M83.65 149.5a2.62 2.62 0 0 0 2.52 3.34h15.6v-3.34z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint10_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M119.03 146.42a3.1 3.1 0 0 0-2.95-2.23h-28.6a3.1 3.1 0 0 0-2.95 2.23l-.88 3.08h36.25z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint11_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.78 102.2H56.95V130h44.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "m84.8 111.05-3.62 3.59v-3.59h-7.25v12.66h7.25v-3.59l3.63 3.59z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint12_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m84.8 111.05-3.62 3.59v-3.59h-7.25v12.66h7.25v-3.59l3.63 3.59z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-orange, #FF8164)",
			d: "m139.06 92.59 7.55-8.06V74.39h-44.83v27.8h44.83v-12.7zm-6.69-1.06-4.28 4.29-3.42-3.42-3.69 3.11-3.9-4.63 3.3-2.78-3.05-3.05 4.28-4.28 3.42 3.4 3.69-3.1 3.9 4.63-3.3 2.78z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint13_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M146.61 84.53V74.39h-44.83v27.8h44.83V89.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint14_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m125.02 84.18-3.41-3.41-4.29 4.28 3.05 3.05"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint15_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m124.67 92.4 3.42 3.41 4.28-4.28-3.05-3.05"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint16_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m117.08 90.88 3.9 4.63 11.64-9.81-3.9-4.63z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint17_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M146.61 102.2h-44.83V130h44.83z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint18_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M125.51 111.94a3.3 3.3 0 0 0 2.76 2.46 3.8 3.8 0 0 0 3.46-1.54"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M124.85 112.07a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint19_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M124.85 112.07a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M143.28 118.78c-.93-.58-2.46-.31-1.91-2.38.44-1.7 1.8-4.42.02-7.4-1.8-3.03-5.78-3.6-7.97-1.29-3.15-1.08-2.83 5.16-2.88 6.36-.01.41-.17.54-.57.7-2.4 1-3.8 1.48-4.72 2.37a2.8 2.8 0 0 0-.86 2.75c.31.9 1.25 1.54 1.7 2.34q2.72-1.38 5.73-1.73l.39-5.33c-1.27-1.37-.02-6.28 2.06-6.28.96 0 1.35 1.05 1.57 2.57 1.25-.89 1.48.95.2 1.96l1.54 7.41c2.13.5 4.13 1.43 5.88 2.73.97-1.43 1.18-3.94-.18-4.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint20_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M143.46 123.57c.97-1.44 1.18-3.95-.18-4.8-.93-.57-2.46-.3-1.91-2.37.44-1.7 1.8-4.42.02-7.4-1.8-3.03-5.78-3.6-7.97-1.29-3.15-1.08-2.83 5.16-2.88 6.36-.01.41-.17.54-.57.7-2.4 1-3.8 1.48-4.72 2.37a2.8 2.8 0 0 0-.86 2.75c.31.9 1.25 1.54 1.7 2.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint21_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.82 120.5a15.5 15.5 0 0 0-12.84 9.5h27.63v-3.26a15.6 15.6 0 0 0-9.04-5.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint22_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M136.04 113.42c1.28-1 1.05-2.84-.2-1.96-.22-1.51-.61-2.57-1.57-2.57-2.08 0-3.33 4.92-2.06 6.28l-.4 5.22.72 9.6 5.05-9.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "m132.2 115.17-.18 2.42a4.4 4.4 0 0 0 2.86-2.16 2.2 2.2 0 0 1-2.67-.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint23_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m132.2 115.17-.18 2.42a4.4 4.4 0 0 0 2.86-2.16 2.2 2.2 0 0 1-2.67-.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint24_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M134.88 115.43c.47-.5.77-1.14.87-1.82q.15-.07.3-.19"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint25_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M65.67 74.39h-8.72v27.8h44.83V74.4H66.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint26_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.78 98.43c-3.32-4.94-11.9-7.8-21.02-8.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint27_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M74.5 90.2c-6.8.46-13.3 2.27-17.55 5.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint28_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M79.98 84.54c1.15 2.85 3.23 3.19 5.26.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M76.26 81.84c.43-2.97 2.75-3.6 3.71-1.03v-2.76a1.23 1.23 0 0 0-1.6-1.17c-.97.3-2.03.72-2.19 1.16a15 15 0 0 0-.34 3.6q.23.05.42.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint29_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M76.26 81.84c.43-2.97 2.75-3.6 3.71-1.03v-2.76a1.23 1.23 0 0 0-1.6-1.17c-.97.3-2.03.72-2.19 1.16a15 15 0 0 0-.34 3.6q.23.05.42.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint30_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m80.73 89.88-.8-5.26c.95-2.36-.08-5.42-1.69-5.42-.96 0-1.76 1.12-1.98 2.64-1.25-.9-1.47.93-.22 1.94l-1.45 5.82a3.13 3.13 0 1 0 6.14.29"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M79.94 84.62c-.55 1.35-1.67 2.02-2.68 1.08.76 1.12 1.81 2 3.07 1.55z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint31_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M79.94 84.62c-.55 1.35-1.67 2.02-2.68 1.08.76 1.12 1.81 2 3.07 1.55z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint32_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M75.62 83.33q.28.41.73.66c.25 1 .92 2.15 1.9 2.15"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M86.04 85.66a1.8 1.8 0 1 0 0-3.61 1.8 1.8 0 0 0 0 3.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint33_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M86.04 85.66a1.8 1.8 0 1 0 0-3.61 1.8 1.8 0 0 0 0 3.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint34_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M63.63 64.32h-.64l4.93 13-9.95-13H46.1a4.34 4.34 0 0 1-4.18-3.2l-5.24-19.43a3.1 3.1 0 0 1 3-3.9H57.2A4.34 4.34 0 0 1 61.38 41l5.23 19.42a3.1 3.1 0 0 1-2.98 3.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint35_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M45.85 47.35h9.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint36_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M46.77 50.74h9.41"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint37_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M48.16 54.49h9.41"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint38_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M22.84 139.48c-2.53.78-4.96.21-5.53-1.35-.57-1.57.91-3.57 3.35-4.6l-.95-2.61c-3.99 1.63-6.32 5.25-5.22 8.23 1.09 3 5.2 4.26 9.3 2.93z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M27.7 121.17c-1.86-.42-1.18-1.39-.97-2.86.61-4.4-6.18-3.92-6.46-3.96-3.96-.56-4.41-4.24-5.3-5.44-1.33-1.8-4.87-2.65-7.46-1.13A5 5 0 0 0 5 112.11c.07 2.42 2.07 4.37 4.25 5.42s4.61 1.45 6.82 2.42c2.59 1.12 1.84 2.32 1.37 3.87a5.2 5.2 0 0 0 1.32 4.51c-.44-1.22 2.12-3.27 5.73-4.6 3.58-1.3 6.83-1.39 7.33-.21-.5-1.28-3-2.1-4.12-2.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint39_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M27.7 121.17c-1.86-.42-1.18-1.39-.97-2.86.61-4.4-6.18-3.92-6.46-3.96-3.96-.56-4.41-4.24-5.3-5.44-1.33-1.8-4.87-2.65-7.46-1.13A5 5 0 0 0 5 112.11c.07 2.42 2.07 4.37 4.25 5.42s4.61 1.45 6.82 2.42c2.59 1.12 1.84 2.32 1.37 3.87a5.2 5.2 0 0 0 1.32 4.51c-.44-1.22 2.12-3.27 5.73-4.6 3.58-1.3 6.83-1.39 7.33-.21-.5-1.28-3-2.1-4.12-2.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint40_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M31.84 123.56c-.44-1.22-3.73-1.14-7.34.18s-6.18 3.37-5.73 4.6l5.95 16.3c-.38-1.22 2.17-3.25 5.74-4.56 3.61-1.31 6.9-1.4 7.35-.18z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-dark, #6A89C1)",
			fillRule: "evenodd",
			d: "M31.4 128.53c-1.09-2.99-7.18-1.66-7.18-1.66l2.75 7.54c1.23-.64 5.51-2.9 4.43-5.88m-6.73 8.88c-.47-1.29 1.07-2.35 2.3-3l1.36 3.74s-3.13.71-3.66-.74",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint41_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M37.8 139.9c-.44-1.22-3.73-1.14-7.34.18s-6.17 3.38-5.73 4.6c.45 1.22 3.74 1.14 7.35-.18s6.17-3.38 5.73-4.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint42_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m158.76 108.74 10.6-4.22"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint43_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m158.76 111.37 11.52-.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint44_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m158.76 114.3 10.6 3.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint45_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M38.61 81.48a9.04 9.04 0 0 0 0 16.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint46_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M41.58 83.49a6.8 6.8 0 0 0 0 12.09"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint47_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M43.7 86.18a3.77 3.77 0 0 0 0 6.71"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint48_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m99.57 66.96-4.22-6.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint49_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.96 66.96v-7.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint50_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m104.3 66.96 3.91-6.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint51_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m141.04 54.89 6.4 6.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint52_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m141.04 61.29 6.4-6.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint53_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M185.18 75.57c0 15.17-19.02 22.08-28.88 9.93l-17.24 7.09 13.97-14.91s-.14-1.4-.14-2.1a16.15 16.15 0 1 1 32.3 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint54_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.05 72.05h12.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint55_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.05 75.44h12.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#meeting-link_svg__paint56_linear_4001_8137)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M163.05 79.2h12.6"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint0_linear_4001_8137",
				x1: 171.361,
				x2: 177.191,
				y1: 144.421,
				y2: 134.435,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint1_linear_4001_8137",
				x1: 95.183,
				x2: 96.731,
				y1: 77.427,
				y2: 68.549,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint2_linear_4001_8137",
				x1: 88.567,
				x2: 110.729,
				y1: 112.623,
				y2: 84.093,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint3_linear_4001_8137",
				x1: 101.281,
				x2: 102.538,
				y1: 72.183,
				y2: 71.073,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint4_linear_4001_8137",
				x1: 85.357,
				x2: 85.78,
				y1: 159.625,
				y2: 154.081,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint5_linear_4001_8137",
				x1: 85.365,
				x2: 88.493,
				y1: 148.701,
				y2: 133.898,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint6_linear_4001_8137",
				x1: 88.035,
				x2: 88.379,
				y1: 139.811,
				y2: 135.22,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint7_linear_4001_8137",
				x1: 96.708,
				x2: 98.225,
				y1: 150.026,
				y2: 144.372,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint8_linear_4001_8137",
				x1: 108.358,
				x2: 108.823,
				y1: 151.751,
				y2: 149.507,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint9_linear_4001_8137",
				x1: 90.13,
				x2: 90.595,
				y1: 151.751,
				y2: 149.507,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint10_linear_4001_8137",
				x1: 96.736,
				x2: 97.336,
				y1: 147.771,
				y2: 144.151,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint11_linear_4001_8137",
				x1: 73.135,
				x2: 82.307,
				y1: 120.949,
				y2: 107.884,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint12_linear_4001_8137",
				x1: 77.856,
				x2: 82.132,
				y1: 119.591,
				y2: 116.345,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint13_linear_4001_8137",
				x1: 117.964,
				x2: 127.136,
				y1: 93.148,
				y2: 80.083,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint14_linear_4001_8137",
				x1: 120.102,
				x2: 122.667,
				y1: 85.715,
				y2: 83.336,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint15_linear_4001_8137",
				x1: 127.452,
				x2: 130.018,
				y1: 93.429,
				y2: 91.05,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint16_linear_4001_8137",
				x1: 122.686,
				x2: 127.748,
				y1: 90.815,
				y2: 86.005,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint17_linear_4001_8137",
				x1: 117.964,
				x2: 127.136,
				y1: 120.949,
				y2: 107.884,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint18_linear_4001_8137",
				x1: 127.756,
				x2: 128.41,
				y1: 113.616,
				y2: 112.169,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint19_linear_4001_8137",
				x1: 124.344,
				x2: 125.601,
				y1: 110.893,
				y2: 109.783,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint20_linear_4001_8137",
				x1: 131.506,
				x2: 137.565,
				y1: 117.95,
				y2: 111.776,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint21_linear_4001_8137",
				x1: 128.954,
				x2: 131.201,
				y1: 126.907,
				y2: 121.126,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint22_linear_4001_8137",
				x1: 133.82,
				x2: 137.254,
				y1: 123.129,
				y2: 122.284,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint23_linear_4001_8137",
				x1: 133.053,
				x2: 133.9,
				y1: 116.804,
				y2: 115.921,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint24_linear_4001_8137",
				x1: 135.297,
				x2: 135.869,
				y1: 114.777,
				y2: 114.483,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint25_linear_4001_8137",
				x1: 73.135,
				x2: 82.307,
				y1: 93.148,
				y2: 80.083,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint26_linear_4001_8137",
				x1: 88.349,
				x2: 90.505,
				y1: 95.737,
				y2: 90.896,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint27_linear_4001_8137",
				x1: 63.285,
				x2: 64.523,
				y1: 93.95,
				y2: 90.495,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint28_linear_4001_8137",
				x1: 81.879,
				x2: 82.57,
				y1: 86.163,
				y2: 84.831,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint29_linear_4001_8137",
				x1: 77.331,
				x2: 79.005,
				y1: 80.206,
				y2: 78.986,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint30_linear_4001_8137",
				x1: 76.764,
				x2: 80.14,
				y1: 88.835,
				y2: 87.527,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint31_linear_4001_8137",
				x1: 78.371,
				x2: 79.336,
				y1: 86.478,
				y2: 85.526,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint32_linear_4001_8137",
				x1: 76.565,
				x2: 77.534,
				y1: 85.225,
				y2: 84.425,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint33_linear_4001_8137",
				x1: 85.54,
				x2: 86.797,
				y1: 84.484,
				y2: 83.374,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint34_linear_4001_8137",
				x1: 47.892,
				x2: 60.926,
				y1: 64.469,
				y2: 55.341,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint35_linear_4001_8137",
				x1: 49.245,
				x2: 49.328,
				y1: 48.02,
				y2: 47.328,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint36_linear_4001_8137",
				x1: 50.17,
				x2: 50.253,
				y1: 51.413,
				y2: 50.721,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint37_linear_4001_8137",
				x1: 51.559,
				x2: 51.642,
				y1: 55.165,
				y2: 54.473,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint38_linear_4001_8137",
				x1: 17.671,
				x2: 21.564,
				y1: 138.805,
				y2: 135.989,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint39_linear_4001_8137",
				x1: 14.682,
				x2: 22.125,
				y1: 121.393,
				y2: 113.127,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint40_linear_4001_8137",
				x1: 25.606,
				x2: 33.046,
				y1: 137.505,
				y2: 131.789,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint41_linear_4001_8137",
				x1: 29.438,
				x2: 31.384,
				y1: 143.429,
				y2: 139.949,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint42_linear_4001_8137",
				x1: 162.581,
				x2: 163.689,
				y1: 107.365,
				y2: 104.906,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint43_linear_4001_8137",
				x1: 162.917,
				x2: 162.921,
				y1: 111.287,
				y2: 111.118,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint44_linear_4001_8137",
				x1: 162.581,
				x2: 163.22,
				y1: 116.379,
				y2: 114.433,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint45_linear_4001_8137",
				x1: 35.464,
				x2: 38.311,
				y1: 92.347,
				y2: 91.577,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint46_linear_4001_8137",
				x1: 39.212,
				x2: 41.348,
				y1: 91.645,
				y2: 91.067,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint47_linear_4001_8137",
				x1: 42.386,
				x2: 43.573,
				y1: 90.706,
				y2: 90.385,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint48_linear_4001_8137",
				x1: 96.875,
				x2: 98.902,
				y1: 64.711,
				y2: 63.621,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint49_linear_4001_8137",
				x1: 102.319,
				x2: 102.93,
				y1: 64.513,
				y2: 64.441,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint50_linear_4001_8137",
				x1: 105.711,
				x2: 107.653,
				y1: 64.711,
				y2: 63.742,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint51_linear_4001_8137",
				x1: 143.353,
				x2: 145.58,
				y1: 59.207,
				y2: 57.239,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint52_linear_4001_8137",
				x1: 143.353,
				x2: 145.58,
				y1: 59.207,
				y2: 57.239,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint53_linear_4001_8137",
				x1: 155.708,
				x2: 167.1,
				y1: 81.803,
				y2: 67.808,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint54_linear_4001_8137",
				x1: 167.6,
				x2: 167.663,
				y1: 72.725,
				y2: 72.029,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint55_linear_4001_8137",
				x1: 167.6,
				x2: 167.663,
				y1: 76.118,
				y2: 75.422,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "meeting-link_svg__paint56_linear_4001_8137",
				x1: 167.6,
				x2: 167.663,
				y1: 79.87,
				y2: 79.174,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			})
		] })
	]
});
export default SvgMeetingLink;
